<template>
  <div>
    <v-dialog persistent v-model="showSelectBeacon" max-width="600">
      <v-card>
        <v-card-text>
          <div class="form-control">
            <v-container>
              <span class="headline primary-color"> เลือก Beacon สำหรับตอบกลับข้อความ </span>
              <v-combobox
                v-model="select"
                :loading="loadingCombo"
                :items="items"
                deletable-chips
                item-text="name"
                multiple
                chips
                color="primary"
              >
                <template slot="item" slot-scope="data">
                  {{ data.item.name }} ({{ data.item.beacon_id }})
                </template>
              </v-combobox>
            </v-container>
          </div>
          <div class="text-xs-center">
            <v-btn depressed color="primary" @click="onAddAdsBeacon">{{ $t('Add') }}</v-btn>
            <v-btn outline color="grey" @click="$emit('closeShowSelectBeacon')">{{
              $t('cancel')
            }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: null
    },
    showSelectBeacon: {
      default: false
    }
  },
  data: () => ({
    select: [],
    items: [],
    loadingCombo: false
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.getBeaconsList(100, 0)
  },
  methods: {
    async getBeaconsList(limit, offset) {
      this.loadingCombo = true
      var res = await api.getBeaconsList({
        pageid: this.selectedBot.pageid,
        limit: limit,
        offset: offset
      })
      if (res.success) {
        this.items = res.result
        if (this.value) {
          const myArray = this.value.split(',')
          res.result.map(item => {
            myArray.map(data => {
              if (item.beacon_id === data) {
                this.select.push(item)
              }
            })
          })
        }
        this.loadingCombo = false
      }
    },
    async onAddAdsBeacon() {
      var arr = []
      await this.select.map(item => {
        if (typeof item.beacon_id !== 'undefined') {
          arr.push(item.beacon_id)
        }
      })

      this.$emit('input', arr.toString())
      this.$emit('closeShowSelectBeacon')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentSelectBeacon.vue